module.exports = __webpack_public_path__ + "img/icon_date.b43cff65.svg";